import React, { useMemo, useState } from 'react'

import DaiChatPanelSizeContext from 'contexts/DaiChatPanelSizeContext'
import { PANEL_WIDTH } from 'layouts/Main/components/DaiChatPanel/styles'

const DaiChatPanelSizeProvider = ({ children }) => {
  const [panelWidth, setPanelWidth] = useState(PANEL_WIDTH)

  const value = useMemo(() => ({ panelWidth, setPanelWidth }), [panelWidth])

  return (
    <DaiChatPanelSizeContext.Provider value={value}>
      {children}
    </DaiChatPanelSizeContext.Provider>
  )
}

export default DaiChatPanelSizeProvider
